import i18next from 'i18next';
import { all, put, call, takeEvery } from 'redux-saga/effects';
import { PapiDaSharedDeviationSubmitSchedule } from '@wix/da-papi-types';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { addErrorNotification } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import { NotificationDuration } from '@wix/da-shared-react/pkg/Notifications/Notification';
import {
  scheduleDraftPublish,
  scheduleDraftPublishSuccess,
  scheduleDraftPublishError,
} from '../actions';
import { SCHEDULE_ERROR_MAXED_OUT, SCHEDULE_ERROR_TIMESLOT_FULL } from '../constants';

function* scheduleDraftPublishSaga({
  payload: { deviation, scheduleTs, onSuccess },
}: ReturnType<typeof scheduleDraftPublish>) {
  const data = {
    stashid: deviation.deviationId,
    scheduled_time: scheduleTs,
  };

  const response: PapiDaSharedDeviationSubmitSchedule = yield call(requestPuppy, {
    method: 'post',
    url: 'deviation/submit/schedule',
    data,
  });

  if (!response || isApiError(response)) {
    yield put(
      scheduleDraftPublishError(
        deviation.deviationId,
        (response as { errorCode?: number }).errorCode ?? null
      )
    );
    return;
  }

  yield put(
    scheduleDraftPublishSuccess({
      deviation,
      scheduleTs,
      status: response.status,
    })
  );

  if (onSuccess) {
    yield call(onSuccess);
  }
}

function* scheduleDraftPublishErrorSaga({
  payload: { errorCode },
}: ReturnType<typeof scheduleDraftPublishError>) {
  // we have a specific UI for the "schedule limit reached" error
  if (errorCode === SCHEDULE_ERROR_MAXED_OUT || errorCode === SCHEDULE_ERROR_TIMESLOT_FULL) {
    yield put(pushModal(ModalType.DEVIATION_SUBMIT_SCHEDULE_LIMIT_REACHED, {}));
    return;
  }

  yield put(
    addErrorNotification(i18next.t('deviationSubmit.error.schedule'), NotificationDuration.S)
  );
}

export default function* scheduleSaga() {
  yield all([
    takeEvery(scheduleDraftPublish, scheduleDraftPublishSaga),
    takeEvery(scheduleDraftPublishError, scheduleDraftPublishErrorSaga),
  ]);
}
